import { Skeleton } from "@mui/material";

export default function CoAppDataGridSkeletonCell(props) {
	const { height = 20, cellToRender, isLoading = false } = props;
	return (
		<>
			{
				isLoading
					?
					<Skeleton variant="rectangular" width="100%" height={height} sx={{ borderRadius: "10px", marginTop: "15px" }} />
					:
					{ ...cellToRender }
			}
		</>
	);
}